export default __webpack_public_path__ + "static/media/signetsimple_dark.cb1d21c3.png";